import { useOrganizationsShortQuery } from '@common/cache';
import { useNavigate } from 'react-router-dom';
import { useReportStore } from '@store';
import { useHandleSaveReport } from '../../../hooks';

export const useReport = () => {
  const navigate = useNavigate();
  const {
    report,
    isModalOpen,
    setIsModalOpen,
    clearAll,
    hideSaveOptions,
    isOwner,
  } = useReportStore();

  const { data: organizationOptions = [] } = useOrganizationsShortQuery();

  const organization = organizationOptions.find(
    o => o.id === report?.report_folder?.organization?.id,
  );

  const handleNavigateToPreview = () => {
    navigate('/reporting/preview');
  };

  const handleDiscard = () => {
    clearAll();
    navigate('/reporting');
  };

  const { handleSaveReport, isPending } = useHandleSaveReport();

  return {
    report,
    organization,
    isModalOpen,
    setIsModalOpen,
    handleNavigateToPreview,
    handleSaveReport,
    handleDiscard,
    hideSaveOptions,
    isPending,
    isOwner,
  };
};
